import { createContext } from 'react';

import { SortOrder } from '../enums';
import { TableContextProvider } from '../interfaces/common';

export const TableContext = createContext<TableContextProvider>({
  headerSection: '',
  row: '',
  noDataFoundMessage: '',
  headCells: [],
  order: SortOrder.asc,
  orderBy: '',
  page: 0,
  perPage: 10,
  total: 0,
  loading: false,
  data: [],
  rowProps: {},
  pagination: true,
  stickyHeader: false,
  setPage: () => {},
  setPerPage: () => {},
  setOrder: () => {},
  setOrderBy: () => {},
});
